const routesNames = {
  home: "home",
  maintenancePage: "maintenance page",
  notAllowedPage: "not allowed page",
  error500: "500",
  error404: "404",
  login: "Login",
  register: "Register",
  userAdd: "Add User",
  userEdit: "Edit User",
  userDetails: "User Details",
  roles: "Roles",
  roleAdd: "Add Role",
  roleEdit: "Edit Role",
  activities: "Activities",
  activityDetails: "Activity Details",
  profile: {
    profile: "profile",
    email: "email",
    details: "personalDetails"
  },
  administration: {
    scopes: "Scopes",
    scopeDashboard: "Scope dashboard",
    languages: "Languages",
    permissions: "permissions",
    users: "Users",
    userDetails: "userDetails",
    maintenanceConfig: "maintenance configuration",
    errorConfig: "error configuration",
    dictionary: "dictionary",
    helpConfig: "help configuration",
    emailTemplate: "Email Templates",
    logs: "logs",
    jobsLogs: "jobs logs",
    policies: "policies",
    termsAndConditions: "terms-and-conditions",
    privacyPolicy: "privacy-policy",
    editTermsAndConditions: "edit-terms-and-conditions",
    editPrivacyPolicy: "edit-privacy-policy",
    navCredentials: "nav credentials",
    mailCredentials: "mail credentials",
    scopeEmails: "scope emails",
    connectivityTest: "connectivity checking",
    sms: "sms",
    smsTemplates: "sms templates",
    smsHistory: "sms history",
    smsCredentials: "sms credentials",
    smsSettings: "sms settings",
    smsLogs: "sms logs",
    monitoringJobs: "Monitoring jobs",
    lastJobs: "Last jobs",
    pendingJobs: "Pending jobs",
    failedJobs: "Failed jobs",
    timesheetConfig: "Timesheet config",
    cronConfig: "Cron config",
    editCronConfig: "Edit cron config",
    invoices: "invoices",
    editEmailTemplates: 'Edit email templates'
  },
  help: {
    help: "help center",
    questions: "questions",
    add_question: "add question",
    edit_question: "edit question",
  },
  editEmailCallback: "Edit Email Callback",
  timesheets: "timesheets",
  timesheetDetails: "timesheet details",
  timesheetApproved: "timesheet approved",
  signUp: "sign up",
  invoices: "invoices",
  addInvoice: "add invoice",
  editInvoice: "edit invoice",
  invoiceDetails: "invoice details",
}

export default routesNames;
